import { NoDataIcon } from '@synergy/theme';
import { PoolTypography } from '@synergy/components';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: 250,
        '& > p': {
            color: '#979797',
            whiteSpace: 'pre',
            textAlign: 'center',
        },
    },
    icon: {
        marginBottom: 18,
        width: 26,
        height: 26,
    },
}));

export const ContactDetailsNoData = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <NoDataIcon className={classes.icon} />
            <PoolTypography typography="body2" id="app.contacts.noData" />
        </div>
    );
};
